import { getSmoothStepPath, BaseEdge, type EdgeProps } from '@xyflow/react';

const FlowEdge = ({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
}: EdgeProps) => {
    const [path] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });
    return (
        <>
            <BaseEdge
                id={id}
                path={path}
                // markerEnd={`url(#${id}-arrowclosed)`}
                interactionWidth={50}
                data-testid={`flow-edge`}
            />
            {/* <defs>
                <marker
                    id={`${id}-arrowclosed`}
                    markerWidth="12.5"
                    markerHeight="12.5"
                    viewBox="-10 -10 20 20"
                    orient="auto"
                    refX="0"
                    refY="0">
                    <polyline
                        stroke="rgb(27, 51, 90)"
                        fill="rgb(27, 51, 90)"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        points="-5,-4 0,0 -5,4 -5,-4"
                    />
                </marker>
            </defs> */}
        </>
    );
};

export default FlowEdge;
